module.exports = __webpack_public_path__ + "static/media/Skyfarm Drive, Santa Rosa, CA4.a4eb2a47.jpg";